// export const pythonFileTemplate = `
// import requests
// url = "<url>"
// payload={<payload>}
// <header>
// response = requests.request("<RequestType>", "<url>", <header>, data={<payload>})
// print(response.text)
// `;

// url,
//     json=<payload>,
//     headers=header

export const pythonFileTemplate = `
<Common_Comment>
<Specific_Comment>

import requests
import json

url = "<url>"

payload = <payload>
headers = <header>

response = requests.<RequestType>(
    <requestData>
    )

print("Status Code:", response.status_code)

try:
    data = <response_json>
    print(data)
except ValueError:
    print(response.text)
`;
